import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import ExecutionPage from "./pages/Execution";
import ExecutionsPage from "./pages/Executions";
import ErrorPage from "./pages/Error";

const router = createBrowserRouter([
  {
    path: "/",
    errorElement: <ErrorPage />,
    element: <App />,
    children: [
      { path: "/", element: <ExecutionsPage />, errorElement: <ErrorPage /> },
      { path: "/error", element: <ErrorPage /> },
      {
        path: "/:executionId",
        element: <ExecutionPage />,
        errorElement: <ErrorPage />,
      },
    ],
  },
  {
    path: "*",
    element: <App />,
    children: [
      { path: "*", element: <ErrorPage />, errorElement: <ErrorPage /> },
    ],
    errorElement: <ErrorPage />,
  },
]);

export default router;
